var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"contents"},[_vm._t("default",null,{"isOffer":_vm.isOffer,"discount":_vm.discount})],2)}
var staticRenderFns = []

export { render, staticRenderFns }